import Link from 'next/link'
import PdImage from '../pd-image/pd-image'
import AngleRight from '../pd-angle-right/pd-angle-right'
import { useChinaDetector } from '../../common/region-locale'
import { useTranslations } from 'next-intl'
import DOMPurify from 'dompurify'
import { applyExternalLinkRelToHtml } from '@/common/link-rel-helper'

interface StatementProps {
  title: string
  content: string
  jumpUrl: string
  image: string
  imageAlt?: string
}

function Statement({ title, content, jumpUrl, image, imageAlt }: StatementProps) {
  const t = useTranslations()
  // const inChina = useChinaDetector()
  // const jumpUrl = inChina ? '/news/752' : '/news/992'

  const cleanContent = applyExternalLinkRelToHtml(DOMPurify.sanitize(content))
  return (
    <div className="w-full bg-white py-15 laptop:py-12 px-6 laptop:px-0">
      <div className="w-300 max-w-full h-auto mx-auto grid laptop:grid-cols-2 grid-cols-1 gap-12">
        <div className="inline-flex flex-col justify-center shrink w-full h-full laptop:order-1 order-2">
          <h4 className="text-black/90 laptop:text-2xl text-xl font-semibold">{title}</h4>
          <p
            className="text-black/60 text-sm font-normal  leading-relaxed space-y-4 laptop:mt-6 mt-3 laptop:mb-2 mb-1 break-words"
            dangerouslySetInnerHTML={{ __html: cleanContent }}
          ></p>
          <Link href={jumpUrl}>
            <span className="laptop:text-base text-sm flex items-center text-pdblue cursor-pointer">
              {t('KnowMore')}
              <AngleRight theme="PUDUBLUE" size="4x8" />
            </span>
          </Link>
        </div>
        <div className="relative shrink w-full laptop:h-94 h-188px order-1">
          <PdImage alt={imageAlt ?? 'statement'} src={image} useLoader={false} width="100%" enableMask={false} />
        </div>
      </div>
    </div>
  )
}

export default Statement
